import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'next-i18next';
import { List, ListItem, ParagraphMedium } from '../../../primitives/index.js';
import { qaId } from '../../../utils/index.js';
import { OFFER_DETAILS_QA_ID } from '../../../utils/qaId.js';
export const LuggageList = ({
  luggageAmount,
  luggageWeight,
  handLuggageAmount,
  handLuggageWeight
}) => {
  const {
    t
  } = useTranslation('hotelServices');
  if (!luggageAmount && !handLuggageAmount) {
    return null;
  }
  return _jsxs(List, {
    as: "ul",
    spacing: "none",
    children: [handLuggageAmount && _jsx(ListItem, {
      "data-testid": qaId(OFFER_DETAILS_QA_ID, `baggageInfo-Handgepäck`),
      children: _jsx(ParagraphMedium, {
        color: "contentSecondary",
        children: t('handLuggage', {
          context: handLuggageWeight ? 'withWeigth' : 'withoutWeight',
          count: handLuggageAmount,
          weight: handLuggageWeight
        })
      })
    }), luggageAmount && _jsx(ListItem, {
      "data-testid": qaId(OFFER_DETAILS_QA_ID, `baggageInfo-Aufgabegepäckstück`),
      children: _jsx(ParagraphMedium, {
        color: "contentSecondary",
        children: t('checkedLuggage', {
          context: luggageWeight ? 'withWeigth' : 'withoutWeight',
          count: luggageAmount,
          weight: luggageWeight
        })
      })
    })]
  });
};